// extracted by mini-css-extract-plugin
export default {"pill":"RestDayPill_pill__M6EWU","icon":"RestDayPill_icon__jBJGX","text":"RestDayPill_text__RcJCZ"};